// @flow
import type { Dispatch } from 'redux';
import { finectAPI } from '@finect/front-utils/finectAPI';
import { models } from '../../utils';
import type { UserType } from '../../types';

export function setUser(user: UserType) {
  return {
    type: 'SET_USER',
    user
  };
}

export function getLoggedUser(cookie?: string) {
  return (dispatch: Dispatch) =>
    finectAPI({
      version: 'v4',
      path: 'users/me',
      method: 'GET',
      credentials: cookie,
      onSuccess: ({ data }: { data: Object }) => {
        const modelizedUser = models.users(data);
        dispatch(setUser(modelizedUser));
      },
      onError: () => dispatch(setUser({ isLoggedIn: false }))
    });
}
